const home = [
	{
		path: '/',
		name: 'home',
		component: () => import('@/view/home/Home')
	},
	{
		path: '/error/404',
		name: 'error',
		component: () => import('@/view/home/Error')
	},
	{
		path: "*",
		redirect: "/error/404"
	}
]
export default home